/**
 * Step-by-step chat trace logging (dev aid).
 *
 * Prints the whole chat data-flow to the browser console so you can watch each
 * step: REST request → response → store mutation, socket send/event, render.
 *
 * Filter the console by **"CHAT"**. Disable at runtime with
 *   window.__CHAT_TRACE__ = false
 * (or remove these `trace(...)` calls). Only visible in devtools — invisible to
 * normal users.
 */
type Phase = 'rest' | 'socket' | 'store' | 'render' | 'presence' | 'cache'

const COLORS: Record<Phase, string> = {
  rest: '#2563eb', // blue
  socket: '#7c3aed', // purple
  store: '#059669', // green
  render: '#d97706', // amber
  presence: '#db2777', // pink
  cache: '#0891b2', // teal — IndexedDB (local-first)
}

export function trace(phase: Phase, step: string, data?: unknown): void {
  if (typeof window !== 'undefined' && (window as unknown as { __CHAT_TRACE__?: boolean }).__CHAT_TRACE__ === false) {
    return
  }
  const ts = new Date().toISOString().slice(11, 23)
  const label = `%c[CHAT ${ts}] ${phase.toUpperCase()}%c ${step}`
  const style = `color:#fff;background:${COLORS[phase]};padding:1px 5px;border-radius:3px;font-weight:bold`
  if (data !== undefined) {
     
    console.log(label, style, 'color:inherit', data)
  } else {
     
    console.log(label, style, 'color:inherit')
  }
}
